class DrawerTabs extends HTMLElement {
    constructor() {
        super();
        // Cache the title and content elements only once to avoid querying them multiple times
        this.tabsTitle = this.querySelectorAll('.drawer-tabs__title');
        this.tabsContent = this.querySelectorAll('.drawer-tabs__content');
        this.sizeGuideBtn = document.querySelectorAll('.trigger-size-guide')
    }

    connectedCallback() {
        document.querySelectorAll('.drawer-tab').forEach(button => {
            button.addEventListener('click', (event) => this.handleClick(event));
        });

        this.tabsTitle.forEach(title => {
            title.addEventListener('click', (event) => this.handleClick(event));
        });

        this.sizeGuideBtn.forEach(title => {
            title.addEventListener('click', (event) => this.handleClick(event));
            title.addEventListener('click', (event) => this.openDrawerSizeGuide(event));
        });
    }

    handleClick(event) {
        const target = event.target;

        if (target.dataset.tab) {
            this.setActiveTab(target.dataset.tab);
        }
    }

    setActiveTab(tabNumber) {
        // Update the active tab and corresponding content
        this.tabsTitle.forEach(tab => tab.classList.toggle('active-dot', tab.dataset.tab === tabNumber));
        this.tabsContent.forEach(content => content.classList.toggle('hidden', content.dataset.tab !== tabNumber));
    }

    openDrawerSizeGuide() {
        let sizeGuide
        if (window.innerWidth < 999) {
            sizeGuide = document.querySelector('.product-page__popover');
            sizeGuide.open = true;
        } else {
            sizeGuide = document.querySelector('.product-page__drawer');
            sizeGuide.open = true;
        }
    }
}

window.customElements.define("drawer-tabs", DrawerTabs);